var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('transition',[_c('router-view')],1)],1),_c('ScrollTop'),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }